import React, { useContext } from "react";
import { AdminBulkActivity } from "app/userManagement/modules/admin/features";
import { OperatorBulkActivity } from "app/userManagement/modules/operator/features";
import { ProviderBulkActivity } from "app/userManagement/modules/provider/features";

import { storageHelper } from "lib/helpers";
import { PrivateContext } from "lib/context";
import { SkeletonAnnotated } from "lib/components";
import constant from "lib/constant/constant";

const { userKey } = constant;
const { admin, operator, provider } = userKey;

const BulkActivity = () => {
  const { isLoading } = useContext(PrivateContext);
  const getComponent = (role) => {
    if (isLoading) {
      return <SkeletonAnnotated />;
    }
    if (role === admin) {
      return <AdminBulkActivity />;
    }
    if (role === operator) {
      return <OperatorBulkActivity />;
    }
    if (role === provider) {
      return <ProviderBulkActivity />;
    }
    return null;
  };

  const currentUserRole = storageHelper.get("userRole");
  const BulkActivityComponent = getComponent(currentUserRole);
  return BulkActivityComponent;
};

export default BulkActivity;
